module.exports = __webpack_public_path__ + "img/3.996a80af.png";